<ng-container *ngIf="translate$ | async"></ng-container>
<ng-container *ngIf="userAttributes$ | async"></ng-container>
<ng-container *ngIf="mfacheck$ | async"></ng-container>
<ng-container *ngIf="loadingPage$ | async"></ng-container>

<app-error-view *ngIf="loginMfaSetupRequired$ | async">
  {{'mfa_required'|translation}}
</app-error-view>

<div
  id="App"
  *ngIf="(loginMfaSetupRequired$ | async) !== true"
  [ngClass]="{ 'hide-menu': hideMenu }">
  <ng-container *ngIf="notificationStatus$ | async"></ng-container>
  <scaffold-layout
    [ngClass]="{ 'nb-layout-iframe': iframeService?.isInIframe }"
    [showFrame]="!iframeService?.isInIframe"
    [leftSidebarState]="sideNavState">
    <div
      layout-header
      *ngIf="!hideMenu"
      [ngClass]="{ 'nb-layout-header-hide': iframeService?.isInIframe }">
      <div id="header-bar" *ngIf="!iframeService?.isInIframe">
        <div class="env-notice" *ngIf="env">
          This is a {{ env }} Environment
        </div>
        <div class="scaffold-toolbar">
          <button
            #scaffoldMenuToggle
            tourTarget
            [tourId]="'scaffold-theme-setup,create-integration,create-import'"
            [stepId]="'step-1,step-1,step-1'"
            [tourPosition]="'left,left,left'"
            class="hamburger-btn"
            [class.is-open]="sideNavState === 'compacted'"
            [attr.tabindex]="headerButtonTabIndex"
            (click)="leftNavtoggle()"
            aria-label="Toggle Scaffold menu visibility">
            <span class="hamburger-box">
              <span class="hamburger-line"></span>
              <span class="hamburger-line"></span>
              <span class="hamburger-line"></span>
            </span>
          </button>
          <a routerLink="/home" class="school-logo-wrapper">
            <img
              class="school-logo"
              src="school-assets/school_logo.png"
              alt="Navigate to landing page link image"
          /></a>
          <a routerLink="/home" class="school-logo-wrapper-dark">
            <img
              class="school-logo"
              src="school-assets/school_logo_dark.png"
              alt="Navigate to landing page link image"
              *ngIf="!darkLogoError; else fallbackLogo"
              (error)="darkLogoError = true"
          /></a>
          <ng-template #fallbackLogo>
            <img
              class="school-logo"
              src="school-assets/school_logo.png"
              alt="Navigate to landing page link image" />
          </ng-template>
          <span class="header-padding"></span>
          <div style="display: flex; gap: 5px; margin-right: 5px">
            <div class="notification-button-wrapper" style="position: relative">
              <div
                class="notification-button-container"
                [class.active-notifications]="activeNotificationCount != 0">
                <p-button
                  severity="contrast"
                  variant="text"
                  (click)="openNotifications()"
                  icon="fas fa-bell">
                </p-button>
              </div>
              <div class="notification-badge-wrapper">
                <p-badge
                  [value]="activeNotificationCount"
                  severity="warn"
                  badgeSize="small"
                  *ngIf="activeNotificationCount" />
              </div>
            </div>
            <div style="display: flex; align-items: center">
              <scaffold-toggle-slide
                *ngIf="displayAutosave"
                [(ngModel)]="itemsService.autosave"
                status="contrast"
                size="small"
                name="autosave"
                ngDefaultControl
                >{{
                  'autosave' | translation | transformText: 'capitalize'
                }}</scaffold-toggle-slide
              >
            </div>

            <p-button
              severity="contrast"
              variant="text"
              (click)="toggleTheme()"
              aria-label="Toggle theme"
              [icon]="isDarkMode ? 'fa fa-moon' : 'fa fa-sun-bright'">
            </p-button>
          </div>
          <div>
            <p-menu
              #personMenu
              [model]="personalMenu"
              [popup]="true"
              [appendTo]="'body'"></p-menu>
            <p-button
              variant="text"
              severity="contrast"
              (click)="personMenu.toggle($event)"
              class="user-menu-button">
              <span class="user-avatar-slot">
                <ng-container *ngIf="!userInfo">
                  <span
                    class="user-avatar-placeholder user-avatar-loading"
                    aria-hidden="true">
                    <i class="fa-thin fa-circle-user"></i>
                  </span>
                </ng-container>
                <p-avatar
                  *ngIf="userInfo && userInfo.picture && !userAvatarImageError"
                  [image]="userInfo.picture"
                  shape="circle"
                  size="large"
                  (onImageError)="onUserAvatarError()"></p-avatar>
                <span
                  *ngIf="userInfo && (!userInfo.picture || userAvatarImageError)"
                  class="user-avatar-placeholder"
                  aria-hidden="true">
                  <i class="fa-thin fa-circle-user"></i>
                </span>
              </span>

              <span class="user-name-slot">
                <span *ngIf="!userInfo" class="loading-user-dots-wrapper">
                  <app-loading-dots size="4px"></app-loading-dots>
                </span>
                <span
                class="user-name-text"
                *ngIf="displayName">
                {{ displayName }}
              </span>
              </span>
              <i class="fas fa-caret-down user-menu-caret"></i>
            </p-button>
          </div>
        </div>
      </div>
    </div>

    <app-sidebar-nav
      layout-sidebar-left
      tag="main-sidebar"
      [menuItems]="globalLeftMenuItems"
      [footerItems]="footerMenu"
      [isLoading]="loadingMenu"
      [selectedType]="selectedType"
      [features]="features"
      [activeFeature]="activeFeature"
      [isCollapsed]="sideNavState === 'collapsed'"
      (footerModalOpen)="openFooterModal($event)"
      (instanceChanged)="setInstance($event)"
      (activeFeatureChanged)="setActiveFeature($event)">
    </app-sidebar-nav>
    <div class="scaffold-column">
      <div>
        <scaffold-notification-bar
          *ngFor="
            let notification of notificationService.barNotifications() | async
          "
          [notification]="notification"></scaffold-notification-bar>
      </div>
      <div class="app-body-content" (click)="closeProperties($event)">
        <div
          *ngIf="showLoadingContentOverlay"
          class="app-body-content-loading-ovelay">
          <app-overlay
            [showSpinner]="true"
            [overlayStyles]="loadingContentOverlayStyles"></app-overlay>
        </div>
        <div><router-outlet></router-outlet></div>
      </div>

      <div #modalViewRef></div>
    </div>
  </scaffold-layout>
</div>
